import { useState } from 'react'

import { Box, Text, Tooltip } from '@factorialco/deprecated-design-system'
import { Emoji } from 'emoji-mart/dist-es'

interface Props {
  selfReaction: boolean
  count: number
  code: string
  label: JSX.Element | string
  onClick: ((code: string) => Promise<unknown>) | ((code: string) => void)
}

export const EmojiBadge = ({ selfReaction, count, code, label, onClick }: Props) => {
  const [hover, setHover] = useState(false)

  return (
    <Tooltip.Alt attachment="bottom center" open={hover} label={label}>
      <Box
        background={selfReaction ? 'viridian100' : 'transparent'}
        borderRadius={{ all: 'abs008' }}
        flexDirection="row"
        justifyContent="center"
        height="s32"
        width="s48"
        alignItems="center"
        onClick={() => onClick(code)}
        border={{
          all: {
            width: 's1',
            style: 'solid',
            color: selfReaction ? 'viridian1000' : 'grey600',
          },
        }}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        <Box width="s16" height="s16" style={{ display: 'block' }}>
          <Emoji
            emoji={{
              id: code,
              name: code,
              short_names: [],
              imageUrl: '',
            }}
            size={16}
            sheetSize={32}
          />
        </Box>
        <Box paddingLeft="s6">
          <Text.Normal
            size="200"
            weight="semibold"
            color={selfReaction ? 'viridian1000' : 'grey800'}
          >
            {count}
          </Text.Normal>
        </Box>
      </Box>
    </Tooltip.Alt>
  )
}
